import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'

import ResidenceChooseDate from './ResidenceBookingModal/ResidenceChooseDate'
import ActiveResidenceBookings from './ActiveResidenceBookings'
import ActiveOtherResidenceBookings from './ActiveOtherResidenceBookings'


@inject('golfCourseStore', 'userStore')

@observer
class Bookings extends Component {

  componentWillMount() {
    //this.props.golfCourseStore.getGolfCourses()
  }

  render() {
    // const { isGolfCourseData } = this.props.golfCourseStore
    const { isResidenceRole } = this.props.userStore

    return (
      <div>
        {isResidenceRole
          ?
          <Row>
            <Col xs={12} md={6} lg={5} className={'mobile-no-padding'} >
              <ResidenceChooseDate />
            </Col>
            <Col xs={12} md={6} lg={5} className={'mobile-no-padding'} >
              <ActiveResidenceBookings />
              <ActiveOtherResidenceBookings />
            </Col>
          </Row>
          : ''}
      </div>
    )
  }
}

Bookings.propTypes = {
  golfCourseStore: MobxPropTypes.observableObject
}

export default Bookings



// WEBPACK FOOTER //
// /src/components/internal/Residence/Residence.js